import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
import { useActions } from '@/utils/map-state';
import { computed, onMounted, reactive } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import Loading from '@/components/common/popup/LoadingCanvas.vue';
import layoutDefault from '@/layouts/layoutDefault.vue';
import layoutH5 from '@/layouts/layoutH5.vue';
import layoutPC from '@/layouts/layoutPC.vue';
import fifaPC from "@/components/pc/common/fifaPC";
import * as API from '@/api';
import dayjs from "dayjs";
import { isNull } from "lodash-es";
import { useFastOfficialDomain } from "@/composable/commonFunction/getFastOfficialDomain";
export default {
  __name: 'App',
  setup(__props) {
    const route = useRoute();
    const store = useStore();
    const commonActions = useActions('common', ['closeFifaFlag']);
    const state = reactive({});

    //官網domain測速選扯
    useFastOfficialDomain();

    // let isApp = computed(() => store.state.isApp)
    // let isMobile = computed(() => store.state.isMobile)
    // let isH5View = computed(() => store.getters.isH5View)
    const layout = computed(() => {
      var _route$meta;
      return {
        layoutH5,
        layoutPC,
        layoutDefault
      }[((_route$meta = route.meta) === null || _route$meta === void 0 ? void 0 : _route$meta.layout) || 'layoutDefault'];
    });

    // 世界盃浮窗顯示時間
    const FIFACloseDate = dayjs('2022-12-21 00:00:00');
    const isFIFATimes = computed(() => {
      return dayjs().isBefore(FIFACloseDate);
    });
    const isShowFIFA = computed(() => {
      return (isNull(getCookie('showFIFA')) || getCookie('showFIFA') === '1') && store.state.common.showFifaFlag || store.state.common.showFifaForce;
    });

    // before router.beforeEach
    onMounted(() => {
      let currentRoute = route.fullPath;

      // 顯示世界盃浮窗
      if (window.performance.navigation.type === 1) {
        document.cookie = 'showFIFA=1;path=/';
        commonActions.closeFifaFlag({
          'show': true,
          'force': true
        });
      }
      if (!isFIFATimes.value) {
        commonActions.closeFifaFlag({
          'show': false,
          'force': false
        });
      }
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [(_openBlock(), _createBlock(_resolveDynamicComponent(_unref(layout)))), _createVNode(Loading), !_unref(store).getters.isH5View && _unref(isFIFATimes) && _unref(isShowFIFA) ? (_openBlock(), _createBlock(_unref(fifaPC), {
        key: 0
      })) : _createCommentVNode("", true)], 64);
    };
  }
};